import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    MuiIconButton: {
      styleOverrides: {
        root: ({ theme: { unstable_sx: sx } }) => ({
          ...sx({ '.MuiSvgIcon-root': { fontSize: 24 } }),
          variants: [
            {
              props: { color: 'default' },
              style: ({ theme: { unstable_sx: sx, ...theme } }) =>
                sx({ color: theme.palette.text.primary }),
            },
          ],
        }),
        sizeSmall: ({ theme: { unstable_sx: sx } }) => sx({ p: 0.5 }),
        sizeMedium: ({ theme: { unstable_sx: sx } }) => sx({ p: 0.75 }),
        sizeLarge: ({ theme: { unstable_sx: sx } }) => sx({ p: 1 }),
      },
    },
  },
});

export default theme.components;
